import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import {selectUserIsLogged} from '../../../redux/user/user.selectors';
import {createStructuredSelector} from 'reselect';

const PrivateRoute = ({component: Component,isLogged, restricted, ...rest}) => {
    return (
        // restricted = false meaning public route
        // restricted = true meaning restricted route
        <Route {...rest} render={props => (
            isLogged===false ?
                <Redirect to="/" />
            : <Component propstatereduxhack={props.match.params.id?props.match.params.id:null} {...props} />
        )} />
    );
};

const mapStateToProps = createStructuredSelector({
  isLogged:selectUserIsLogged
});
export default connect(mapStateToProps)(PrivateRoute);